<form [formGroup]="userForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="userName">Username:</label>
    <input
      style="text-transform: none !important"
      type="text"
      class="form-control"
      [value]="username"
      disabled
    />
  </div>
  <div class="form-group">
    <label for="email">Email:</label>
    <input
      type="email"
      class="form-control"
      id="userEmail"
      formControlName="email"
      required
      [ngClass]="{ 'is-invalid': hasSubmitted && email.invalid }"
    />
  </div>
  <div class="form-group">
    <label for="userFirstName">First Name:</label>
    <input type="text" class="form-control" id="userFirstName" formControlName="firstName" />
  </div>
  <div class="form-group">
    <label for="userLastName">Last Name:</label>
    <input
      type="text"
      class="form-control"
      id="userLastName"
      aria-label="lastName"
      formControlName="lastName"
    />
  </div>
  <div class="form-group">
    <label for="userEmailSignature">Email Signature:</label>
    <textarea
      rows="6"
      style="text-transform: none !important"
      class="form-control"
      id="userEmailSignature"
      formControlName="emailSignature"
    ></textarea>
  </div>
  <div class="form-group">
    <label for="roleId">Role:</label>
    <select
      id="roleId"
      name="roleId"
      formControlName="roleId"
      class="form-control"
      required
      [ngClass]="{ 'is-invalid': hasSubmitted && roleId.invalid }"
    >
      <option *ngFor="let role of allRoles" [ngValue]="role.id">
        {{ role.rolName }}
      </option>
    </select>
  </div>
  <div class="form-group">
    <input
      type="checkbox"
      id="sendReset"
      formControlName="sendReset"
      style="vertical-align: -12%"
    />
    <label for="sendReset" style="margin-bottom: 0px; padding-left: 10px">
      Send Password Reset Email
    </label>
  </div>
  <p-footer>
    <div class="footer">
      <button type="button" class="btn btn-secondary mr-3" (click)="closeModal()">Cancel</button>
      <button
        *ngIf="selectedUser && !selectedUser.isDeleted"
        type="button"
        class="btn btn-danger mr-3"
        (click)="confirmationDelete()"
      >
        Delete
      </button>
      <button
        *ngIf="selectedUser && !selectedUser.isDeleted"
        type="submit"
        class="btn btn-primary createBtn"
      >
        Save
      </button>
      <button
        *ngIf="selectedUser && selectedUser.isDeleted"
        class="btn btn-primary createBtn"
        (click)="restoreUser(selectedUser.id)"
      >
        Restore User
      </button>
    </div>
  </p-footer>
</form>
